type Spoor = {
  dienstregelpuntspoornaam: string;
  laatstBezetSpoor: string | undefined;
};

type WerklijnDeeltrajectActiviteit = {
  activiteitId: string;
  soort: string;
  dienstregelpunt: string;
  oorspronkelijkGeplandeTijd: string;
  actueelGeplandeTijd: string;
  uitvoeringsTijd: string;
  afrijrichting: string;
  volgnummer: number;
  prognose: number;
  isKnoop: boolean;
  oorspronkelijkesporen?: Spoor[];
  actuelesporen?: Spoor[];
};

type WerklijnDeeltrajectInzet = {
  inzetPositie: number;
  activiteiten: WerklijnDeeltrajectActiviteit[];
  werklijnId: string;
  inzetId: string;
  eenheid: {
    nummer: string;
    materieelType: {
      soort: string;
      aanduiding: string;
    };
    statusovergangen: any;
    inregeling: any;
  };
  treinSamenstelling: {
    samenstelling: string;
    aantalZitplaatsen: number;
    comfortabelNorm: number;
    acceptabelNorm: number;
    volNorm: number;
    inzetPositie: number;
  };
};

export class DetailInzetModel {
  constructor(
    public werklijnId: string,
    public inzetId: string,
    public vorigeInzetId: string,
    public volgendeInzetId: string,
    public eenheid: {
      nummer: string;
      materieelType: {
        soort: string;
        aanduiding: string;
      };
      statusovergangen: any;
      inregeling: any;
    },
    public materieelType: {
      soort: string;
      aanduiding: string;
    },
    public toelichting: string | null,
    public tractie: boolean,
    public opzending: boolean,
    public opengesteld: boolean,
    public oorspronkelijkeDienst: string,
    public bewegingsdeeltraject: {
      vertrek: {
        id: string;
        soort: string;
        dienstregelpunt: string;
        oorspronkelijkGeplandeTijd: string;
        actueelGeplandeTijd: string;
        uitvoeringsTijd: string;
        afrijrichting: string;
        volgnummer: number;
      };
      aankomst: {
        id: string;
        soort: string;
        dienstregelpunt: string;
        oorspronkelijkGeplandeTijd: string;
        actueelGeplandeTijd: string;
        uitvoeringsTijd: string;
        afrijrichting: string;
        volgnummer: number;
      };
      bewegingSleutel: {
        treinnummer: number;
        treindatum: string;
        dienstregelVersie: number;
      };
    },
    public gekoppeldeInzetten: Array<{
      werklijnId: string;
      inzetId: string;
      inzetPositie: number;
      geaccepteerdConflict: boolean;
      eenheid: {
        nummer: string;
        materieelType: {
          soort: string;
          aanduiding: string;
        };
        statusovergangen: any;
        inregeling: any;
      };
      treinSamenstelling: {
        samenstelling: string;
        aantalZitplaatsen: number;
        comfortabelNorm: number;
        acceptabelNorm: number;
        volNorm: number;
      };
      geplandeTreinSamenstelling?: {
        samenstelling: string;
        aantalZitplaatsen: number;
        comfortabelNorm: number;
        acceptabelNorm: number;
        volNorm: number;
      };
    }>,
    public treinSamenstelling: {
      samenstelling: string;
      aantalZitplaatsen: number;
      comfortabelNorm: number;
      acceptabelNorm: number;
      volNorm: number;
      inzetPositie: number;
    },
    public route: {
      laatstGemetenLocatie: {
        dienstregelpunt: string;
        tijd: string;
      };
      activiteiten: Array<{
        activiteitId: string;
        soort: string;
        dienstregelpunt: string;
        oorspronkelijkGeplandeTijd: string;
        actueelGeplandeTijd: string;
        uitvoeringsTijd: string;
        afrijrichting: string;
        volgnummer: number;
        prognose: number;
        isKnoop: boolean;
      }>;
    },
    public conflicten: Array<{
      type: string;
      dienstregelpunt: string;
      tijd: string;
      spoor: string | null;
    }>,
    public werklijnDeeltrajectInzetten: WerklijnDeeltrajectInzet[],
    public geplandeTreinSamenstelling?: {
      samenstelling: string;
      aantalZitplaatsen: number;
      comfortabelNorm: number;
      acceptabelNorm: number;
      volNorm: number;
    },
  ) {}
}

export function mapDetailInzet(rawModel: any): DetailInzetModel {
  return new DetailInzetModel(
    rawModel.werklijnId,
    rawModel.inzetId,
    rawModel.vorigeInzetId,
    rawModel.volgendeInzetId,
    rawModel.eenheid,
    rawModel.materieelType,
    rawModel.toelichting,
    rawModel.tractie,
    rawModel.opzending,
    rawModel.opengesteld,
    rawModel.oorspronkelijkeDienst,
    rawModel.bewegingsdeeltraject,
    rawModel.gekoppeldeInzetten.map((inzet: any) => ({
      werklijnId: inzet.werklijnId,
      inzetId: inzet.inzetId,
      inzetPositie: inzet.inzetPositie,
      eenheid: inzet.eenheid,
      geaccepteerdConflict: inzet.geaccepteerdConflict,
      treinSamenstelling: inzet.treinSamenstelling,
      geplandeTreinSamenstelling: inzet.geplandeTreinSamenstelling || null,
    })),
    rawModel.treinSamenstelling,
    rawModel.route,
    rawModel.conflicten,
    rawModel.werklijnDeeltrajectInzetten,
    rawModel.geplandeTreinSamenstelling || null,
  );
}

export function mapDetailInzetDirect(rawData: any): DetailInzetModel {
  return mapDetailInzet(rawData);
}
